import { User } from 'library/types';
import { renderAutoCompleteLocaleText } from 'utils';
import { gray } from 'providers/theme/themePrimitives';
import { Autocomplete, svgIconClasses, TextField, useTheme } from '@mui/material';
import { GridRenderEditCellParams, useGridApiContext } from '@mui/x-data-grid-premium';

const AppointedConsultantEditCell = (props: GridRenderEditCellParams & { users: User[] }) => {
  const { id, field, value, users } = props;

  const theme = useTheme();
  const apiRef = useGridApiContext();

  const selectedUser = users.find((u) => u.id === value) ?? null;

  return (
    <Autocomplete
      fullWidth
      options={users}
      value={selectedUser}
      {...renderAutoCompleteLocaleText()}
      getOptionLabel={(opt) => opt?.nameSurname ?? ''}
      isOptionEqualToValue={(opt, val) => opt.id === val.id}
      onChange={async (_e, newUser) => {
        const newValue = newUser ? newUser.id : null;

        await apiRef.current.setEditCellValue({ id, field, value: newValue }, { debounceMs: 0 });

        apiRef.current.stopCellEditMode({ id, field });
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          autoFocus
          sx={{
            '& .MuiButtonBase-root': {
              border: 'none',
              backgroundColor: 'inherit',
              width: '2.25rem',
              height: '2.25rem',
              padding: '0.25rem',
              [`& .${svgIconClasses.root}`]: { fontSize: '1rem' },
              '&:hover': {
                backgroundColor: theme.palette.mode === 'light' ? gray[100] : gray[800],
              },
            },
          }}
          placeholder="Danışman ara..."
        />
      )}
    />
  );
};

export default AppointedConsultantEditCell;
